module.exports = __webpack_public_path__ + "static/media/instabtm1.3ac98c65.jpg";